import { Component, OnInit } from "@angular/core";
import { IonicModule, ModalController, NavParams, ToastController } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { FormGeradorPage } from "src/app/pages/form-gerador/form-gerador.page";
import { PessoaEditEnderecoPage } from "src/app/pages/pessoa/pessoa-edit-endereco/pessoa-edit-endereco.page";
import { PessoaProvider } from "src/app/services/pessoa/pessoa";
import { UserProvider } from "src/app/services/user/user";
import { PessoaFotoPage } from "../pessoa-foto/pessoa-foto.page";
import { differenceInYears } from "date-fns";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { ImagePipe } from "src/app/pipes/image/image";
import { PhonePipe } from "src/app/pipes/phone/phone";
import { LoadingController } from "@ionic/angular/standalone";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
import { EnderecoPipe } from "src/app/pipes/endereco/endereco";

declare var instituicaoConstants: {
  IS_CATHOLIC: any;
  IS_CONVENCAO: any;
  BUSCAR_INTITUICOES: number;
  INSTITUICAO: number;
  IS_PWA: boolean;
};

@Component({
  selector: "app-dados-gerais",
  templateUrl: "./dados-gerais.page.html",
  styleUrls: ["./dados-gerais.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    DateFormatPipe,
    TranslateModule,
    ImagePipe,
    PhonePipe,
    LoadingSpinnerComponent,
    EnderecoPipe,
  ],
})
export class DadosGeraisPage implements OnInit {
  membro = false;
  permissao = false;
  idPessoa: any;
  meuCadastro: boolean = false;
  pessoa: any = { contato: {}, endereco: {}, hasMda: {} };
  editar: boolean = false;
  ddi: any;
  visitante: any;
  nomeUsuario: any;
  autorizadoEditar: boolean = false;
  permissaoVisitante = false;
  keyInstituicao: any = "";
  pessoaTipo: boolean = false;
  esconderCadastro: boolean = true;
  public isCatholic: boolean = instituicaoConstants.IS_CATHOLIC;
  public isConvencao: boolean = instituicaoConstants.IS_CONVENCAO;
  public isControle = false;
  mostrarCamera: boolean = false;
  loaded: boolean = false;
  isMobile: any = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    any: function () {
      return this.isMobile.Android() || this.isMobile.iOS();
    },
  };

  constructor(
    public pessoaProvider: PessoaProvider,
    public modalCtrl: ModalController,
    public userProvider: UserProvider,
    public navParams: NavParams,
    private translate: TranslateService,
    public toastCtrl: ToastController,
    public loadingController: LoadingController
  ) {
    this.membro = this.navParams.get("membro");
    this.permissao = this.navParams.get("permissao");
    this.idPessoa = this.navParams.get("idPessoa");
    this.meuCadastro = this.navParams.get("meuCadastro");
    this.autorizadoEditar = this.navParams.get("autorizado") == 1 ? true : false;
    this.permissaoVisitante = this.membro
      ? this.userProvider.hasConfig(104)
      : this.userProvider.hasPermissao("VISITANTE_VISUALIZAR") || this.userProvider.hasPermissao("PESSOA_VISUALIZAR");
    this.userProvider.getDadosInstituicao().then((data) => {
      this.keyInstituicao = data.apiToken;
    });

    this.mostrarCamera = true;
    this.isControle = instituicaoConstants.BUSCAR_INTITUICOES == 2;
    this.pessoaProvider.getbyId(this.idPessoa).subscribe((data) => {
      this.pessoa = data;

      this.nomeUsuario = this.pessoa.nome.split(" ")[0];
      this.ddi = data.contato;

      if (!this.ddi) {
        this.ddi = "55";
      } else {
        this.ddi = data.contato.ddiTelCelular;
      }

      this.visitante = this.userProvider.hasConfig("160");

      if (!this.visitante && this.pessoa.idPessoaTipo == 5) {
        this.pessoaTipo = true;
      }

      if ((this.visitante && this.pessoa.idPessoaTipo != 5) || !this.visitante) {
        this.pessoaTipo = true;
      }

      if (this.userProvider.hasPermissao("PESSOA_EDITAR") && this.pessoa.idPessoaTipo != 5) {
        this.editar = true;
      } else if (this.userProvider.hasPermissao("VISITANTE_EDITAR") && this.pessoa.idPessoaTipo == 5) {
        this.editar = true;
      } else if (this.meuCadastro) {
        this.editar = true;
      }
      this.loaded = true;
    });

    this.userProvider.getDados().then((dados) => {
      this.userProvider.esconderCadastro(dados.instituicao.id).subscribe((data) => {
        this.esconderCadastro = data;
      });

      if (instituicaoConstants.INSTITUICAO != 0) {
        this.userProvider.esconderCadastro(instituicaoConstants.INSTITUICAO).subscribe((data) => {
          this.esconderCadastro = data;
        });
      } else {
        this.esconderCadastro = false;
      }
    });
  }

  ngOnInit() {
    setTimeout(() => {
      this.loaded = true;
    }, 1000);
  }

  async editarDados(pessoa: { idPessoaTipo: number; id: any; idInstituicao: any }) {
    const dados: any = {};

    if (this.meuCadastro) {
      dados.form = "APP_CAD_MEU";
      dados.idPessoaTipo = pessoa.idPessoaTipo;
      dados.titulo = this.translate.instant("Editar Meu Cadastro");
      dados.idPessoa = pessoa.id;
    } else {
      if (pessoa.idPessoaTipo == 5) {
        dados.form = "APP_CAD_VISIT";
        dados.idPessoaTipo = 5;
        dados.titulo = this.translate.instant("Edição de Visitante");
        dados.idPessoa = pessoa.id;
      } else {
        dados.form = "APP_CAD_MEMBRO";
        dados.idPessoaTipo = pessoa.idPessoaTipo;
        dados.titulo = this.translate.instant("Edição de Pessoa");
        dados.idPessoa = pessoa.id;
      }
    }

    dados.idInstituicao = pessoa.idInstituicao;
    const modalPage = await this.modalCtrl.create({
      component: FormGeradorPage,
      componentProps: dados,
    });
    modalPage.present();

    (await modalPage.onWillDismiss()).data;
    if (dados) {
      this.pessoaProvider.getbyId(this.idPessoa).subscribe((data) => {
        this.pessoa = data;
      });
    }
  }

  async editarEndereco(pessoa: { endereco: any; instituicao: any }) {
    const data = {
      endereco: pessoa.endereco,
      idInstituicao: pessoa.instituicao,
    };
    const modalPage = await this.modalCtrl.create({
      component: PessoaEditEnderecoPage,
      componentProps: data,
    });
    modalPage.present();

    const result = await modalPage.onWillDismiss();
    if (result.data) {
      const toast = await this.toastCtrl.create({
        message: this.translate.instant("Endereço atualizado com sucesso!"),
        duration: 3000,
      });
      toast.present();
      this.pessoa.endereco = result.data;
    }
  }

  getIdade(nascimento: string | number | Date) {
    return differenceInYears(new Date(nascimento), new Date());
  }

  async alterarFoto(pessoa: any) {
    const data = { pessoa: pessoa, meuCadastro: this.meuCadastro };
    const modalPage = await this.modalCtrl.create({
      component: PessoaFotoPage,
      componentProps: data,
    });
    modalPage.present();

    const dismissModal = await modalPage.onDidDismiss();
    if (dismissModal.data) {
      this.pessoaProvider.getbyId(this.idPessoa).subscribe(async (data) => {
        const toast = await this.toastCtrl.create({
          message: this.translate.instant("Foto atualizada com sucesso!"),
          duration: 3000,
        });

        toast.present();
        this.pessoa = data;
      });
    }
  }

  public closeModal() {
    this.modalCtrl.dismiss(true);
  }
}
